import api from 'api'
import { WageCoverageScope } from './getJurisdiction'
import { WageJurisdiction } from './getJurisdictions'

export type WageRate = {
  id: number
  hourlyRateCents: number
  note: string | null
  isEnabled: boolean
}

export type WageRule = {
  id: number
  effectiveStart: string
  effectiveEnd: string | null
  coverageScope: WageCoverageScope
  reference: string | null
  jurisdictionIds: number[]
  jurisdictions: WageJurisdiction[]
  rates: WageRate[]
  placeExclusions: string[]
}

export const getRuleById = async (id: number): Promise<WageRule> => {
  const response = await api.get<WageRule>(`/admin/wage/rules/${id}`)
  return response.data
}
